export default {
  
  jobAdvertisement: [],
  jobAdvertisementById: {},

  degree: [],

  collaborationType: [],

  companyField: [],

  jobRequest: [],
  jobRequestById: {},

  socialNetwork: [],

};
